import styled from '@emotion/styled';
import { NavLink } from 'react-router-dom';

import { ButtonPrimary } from '../shared/Buttons';

export const Container = styled('div', {
  shouldForwardProp: (prop) => prop !== 'narrow',
})<{ narrow?: boolean }>`
  color: ${({ theme }) => theme.colors.blueDark70};
  max-width: ${({ narrow }) => (narrow ? '400px' : '560px')};
`;

export const Title = styled.h1`
  ${({ theme }) => theme.textStyles.titleL};
  color: ${({ theme }) => theme.colors.blueDark100};
  margin-bottom: ${({ theme }) => theme.spacers.m};

  ${({ theme }) => theme.mediaQuery.md} {
    font-size: 2rem;
  }
`;

export const TitleLarge = styled(Title)`
  // This is using some other design system than ours, so we need to override text styles
  font-weight: 300;
  font-size: 34px;

  ${({ theme }) => theme.mediaQuery.md} {
    font-size: 48px;
  }
`;

export const Subtitle = styled.p`
  ${({ theme }) => theme.textStyles.labelM};
  margin-bottom: ${({ theme }) => theme.spacers.l};
`;

export const Text = styled.p`
  ${({ theme }) => theme.textStyles.labelL};
  color: ${({ theme }) => theme.colors.blueDark70};
  margin: 0;
  margin-bottom: ${({ theme }) => theme.spacers.m};

  a {
    color: ${({ theme }) => theme.colors.blueDark100};
    text-decoration: underline;
  }
`;

export const Email = styled.span`
  color: ${({ theme }) => theme.colors.blueDark100};
`;

export const ErrorBlock = styled.p`
  ${({ theme }) => theme.textStyles.paragraphS};
  color: ${({ theme }) => theme.colors.blueDark50};
  margin-top: ${({ theme }) => theme.spacers.xl};
`;

export const Inputs = styled.div`
  margin-bottom: ${({ theme }) => theme.spacers.l};

  ${({ theme }) => theme.mediaQuery.md} {
    margin-bottom: ${({ theme }) => theme.spacers.xl};
  }

  & > :not(:first-of-type) {
    margin-top: ${({ theme }) => theme.spacers.xs};
  }
`;

export const InputContainer = styled.div`
  position: relative;
`;

export const TermsText = styled.p`
  ${({ theme }) => theme.textStyles.labelL};
  margin-bottom: ${({ theme }) => theme.spacers.m};

  a {
    color: ${({ theme }) => theme.colors.blueDark100};
    text-decoration: underline;
  }
`;

export const Bullets = styled.ul`
  padding-inline-start: 18px;
  margin-bottom: ${({ theme }) => theme.spacers.xl};

  li {
    font-size: 1.5rem;
    line-height: 14px;
    position: relative;
    left: 5px;
    color: ${({ theme }) => theme.colors.blueDark100};
  }

  li span {
    ${({ theme }) => theme.textStyles.labelL};
    color: ${({ theme }) => theme.colors.blueDark70};
    position: relative;
    left: 4px;
    top: -2px;
  }
`;

export const CheckboxContainer = styled.div`
  margin-right: 10px;
`;

export const CheckboxLabel = styled.label`
  ${({ theme }) => theme.textStyles.labelL};
  display: flex;

  & + & {
    margin-top: ${({ theme }) => theme.spacers.m};
  }
`;

export const ButtonGroup = styled.div`
  margin: ${({ theme }) => theme.spacers.xl} 0 5rem;
`;

export const SubmitButton = styled(ButtonPrimary)`
  width: 100%;

  ${({ theme }) => theme.mediaQuery.md} {
    min-width: 172px;
    width: auto;
  }
`;

export const LoginLink = styled(NavLink)`
  ${({ theme }) => theme.textStyles.titleS};
  display: flex;
  flex-direction: row;
  align-items: center;

  &,
  &:hover {
    color: ${({ theme }) => theme.colors.blueDark100};
    text-decoration: underline;
  }

  svg {
    margin-right: ${({ theme }) => theme.spacers.xs};
  }
`;
